@if (data(); as d) {
  <div class="pc" role="alertdialog" data-testid="hotel-extension-changed-dialog" [attr.aria-labelledby]="titleId">
    <div class="pc-head">
      <h3 class="pc-title" [id]="titleId">
        @if (priceChanged()) {
          {{ 'The price has changed' | translate }}
        } @else if (gone()) {
          {{ 'No longer available' | translate }}
        } @else {
          {{ 'It cannot be booked now' | translate }}
        }
      </h3>
      <button
        type="button"
        class="pc-close"
        data-testid="hotel-extension-changed-close-button"
        [attr.aria-label]="'Close' | translate"
        (click)="choose('cancel')"
      >
        ×
      </button>
    </div>
    <div class="pc-body">
      <p class="pc-text" data-testid="hotel-extension-changed-message">
        @if (priceChanged()) {
          {{ 'The price of the extra night has changed. Nothing was booked yet.' | translate }}
        } @else {
          {{ codeText(d.code) | translate }} {{ 'Nothing was booked yet.' | translate }}
        }
      </p>
      <div class="pc-table">
        <span class="pc-k">{{ kindLabel() | translate }}</span>
        <span data-testid="hotel-extension-changed-night">{{ d.hotelName }} {{ night() }}</span>
        @if (priceChanged()) {
          @if (d.oldSell !== null && d.oldSell !== undefined) {
            <span class="pc-k">{{ 'Was' | translate }}</span>
            <span class="pc-old" data-testid="hotel-extension-changed-old">{{
              d.oldSell | priceFormat: d.currency
            }}</span>
          }
          <span class="pc-k">{{ 'Now' | translate }}</span>
          <span class="pc-new" data-testid="hotel-extension-changed-new">{{
            d.newSell ?? 0 | priceFormat: d.currency
          }}</span>
        }
      </div>
      <div class="pc-alert">
        <span class="pc-code" data-testid="hotel-extension-changed-code">{{ d.code }}</span>
        <app-avia-trace-id testIdPrefix="hotel-extension-changed" [activityId]="d.activityId" />
      </div>
      <div class="pc-actions">
        <button
          type="button"
          class="pc-link"
          data-testid="hotel-extension-changed-cancel-button"
          (click)="choose('cancel')"
        >
          {{ 'Cancel' | translate }}
        </button>
        @if (d.canGoWithout) {
          <button
            type="button"
            class="pc-ghost"
            data-testid="hotel-extension-changed-without-button"
            (click)="choose('without')"
          >
            {{ 'Book without it' | translate }}
          </button>
        }
        @if (priceChanged()) {
          <button
            type="button"
            class="pc-primary"
            data-testid="hotel-extension-changed-accept-button"
            (click)="choose('accept')"
          >
            {{ 'Accept the new price' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
}
